/* iYos — controles de cantidad del carrito.

   Los botones +/− ajustan el input y envían el formulario nativo, así que
   el carrito funciona igual sin JavaScript: el input y el botón
   "Actualizar carrito" ya son parte del form de Shopify. */

(function () {
  'use strict';

  function init(root) {
    const form = root.querySelector('[data-iyos-cart-form]');
    if (!form) return;

    form.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-iyos-step]');
      if (!btn) return;

      const fila = btn.closest('[data-iyos-row]');
      const input = fila && fila.querySelector('[data-iyos-qty]');
      if (!input) return;

      const paso = Number(btn.dataset.iyosStep);
      const nuevo = Math.max(0, (parseInt(input.value, 10) || 0) + paso);
      if (nuevo === (parseInt(input.value, 10) || 0)) return;

      input.value = nuevo;
      enviar(form, fila);
    });

    // Escribir a mano también actualiza, sin obligar a buscar el botón.
    form.addEventListener('change', function (e) {
      const input = e.target.closest('[data-iyos-qty]');
      if (!input) return;
      if (input.value === '' || Number(input.value) < 0) input.value = 0;
      enviar(form, input.closest('[data-iyos-row]'));
    });
  }

  function enviar(form, fila) {
    // Atenúa la fila mientras el navegador recarga: da señal de que algo pasó.
    if (fila) fila.dataset.iyosBusy = 'true';
    form.requestSubmit
      ? form.requestSubmit(form.querySelector('[name="update"]'))
      : form.submit();
  }

  function boot() {
    document.querySelectorAll('[data-iyos-cart]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
